const artikeldetail = document.querySelector('[id^="artikel_detail_"]');

const urlParams = new URLSearchParams(window.location.search);
const fromParam = urlParams.get('from');

if (artikeldetail && (fromParam == null || fromParam.includes('nl_'))) {
    const main = document.querySelector('main');
    const reader = main ? main.lastElementChild : null;

    // Check, ob letztes Element wirklich Reader
    if (reader && reader.classList.contains('iww-teaser-container')) {
        reader.style.display = 'none';
    }
}
